export default __webpack_public_path__ + "static/car-loan-54e1bf7736410dfc9ded46da60a9b8ca.png";